import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/snedson-white-logo.svg'
import _imports_1 from '@/assets/teen2.png'


const _withScopeId = n => (_pushScopeId("data-v-6ba169aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "page-content__left left-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 class=\"left-content__title\" data-v-6ba169aa> Сделайте вашу<br data-v-6ba169aa> школьную жизнь <br data-v-6ba169aa><span class=\"left-content__span\" data-v-6ba169aa>удобнее!</span></h1><p class=\"left-content__description\" data-v-6ba169aa><b data-v-6ba169aa>Snedson</b> Snotra - школьный агрегатор, собирающий все необходимое для удобной учебы в одном месте. <br data-v-6ba169aa>Попробуйте прямо сейчас! </p><a class=\"left-content__auth-button auth-button\" href=\"https://auth.snedson.com\" data-v-6ba169aa><img class=\"auth-button__logo\" src=\"" + _imports_0 + "\" data-v-6ba169aa><div class=\"auth-button__labels\" data-v-6ba169aa><p class=\"auth-button__title\" data-v-6ba169aa>Войти в Snedson Account</p><p class=\"auth-button__subtitle\" data-v-6ba169aa>Демонстрационная версия</p></div></a>", 3)
const _hoisted_6 = { class: "left-content__sns sns" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sns__title" }, "Следите за нами в соц.сетях:", -1))
const _hoisted_8 = { class: "sns__content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sns__address" }, "@snedson", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-content__right right-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "right-content__container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "right-content__teen",
      src: _imports_1
    })
  ])
], -1))

import SocialNetworks from "@/components/social-networks/social-networks.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'homepage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(SocialNetworks),
          _hoisted_9
        ])
      ])
    ]),
    _hoisted_10
  ]))
}
}

})